import { MenuToggler } from "Components/menuGeneric";
import React from "react";
import { IoSettingsOutline } from "react-icons/io5";
import styles from "./SettingsToggler.module.css";
export default function SettingsToggler(props) {
    return (React.createElement(MenuToggler, { onClick: props.onClick, className: `${props.className} ${styles["btn-settings"]} ${props.isOpen ? styles.active : ""}`, id: props.id },
        React.createElement(IoSettingsOutline, null)));
}
